export default Object.freeze({
	Alternate: 'alternate', // B-series
	PhotoLandscape: 'photo-landscape', // L-series and ML-series
	PhotoLandscapeHs: 'photo-landscape-hs', // H-series NetStamps
	PhotoPortrait: 'photo-portrait', // P-series and MP-series
	PromoPaper20: 'promo-paper-20', // L-series
	Promotional: 'promotional', // 9-series
	Standard: 'standard', // C-series and V-series
	Themed: 'themed', // K-series
	Traditional: 'traditional', // 2-series and A-series
	ReturnAddress: 'return-address', // R-series
	RollTypeSorD: 'roll-type-s-or-d', // S-series or D-series
});
